import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IDropdown } from '@models/dropdown.model';

export const AddOrganizationActions = createActionGroup({
  source: 'AddOrganization',
  events: {
    'Page Loaded': emptyProps(),

    'Name Changed': props<{ value: string }>(),
    'Type Changed': props<{ value: number }>(),
    'LegacyID Changed': props<{ value: string }>(),
    'CRM ID Changed': props<{ value: string }>(),
    'Organization ID Changed': props<{ value: string }>(),
    'Address Changed': props<{ value: string }>(),
    'Address B Changed': props<{ value: string }>(),
    'Zip Code Changed': props<{ value: string }>(),
    'City Changed': props<{ value: string }>(),
    'State Changed': props<{ value: number }>(),

    'Create New Organization': props<{ organizationData: any }>(),
    'Create New Organization Success': props<{ details: any }>(),
    'Create New Organization Failure': props<{ error: string }>(),

    'Validity Changed': props<{ validity: boolean }>(),

    'Type Search Changed': props<{ value: string }>(),
    'State Search Changed': props<{ value: string }>(),
    
    'Save Button Pressed': emptyProps(),

    'Get States Success': props<{ contents: IDropdown[] }>(),
    'Get States Failure': props<{ error: string }>(),
    'Get Cities Success': props<{ contents: IDropdown[] }>(),
    'Get Cities Failure': props<{ error: string }>(),

    'Get Organization Types Success': props<{ contents: IDropdown[] }>(),
    'Get Organization Types Failure': props<{ error: string }>(),

    'Get Organization Details Success': props<{ details: any }>(),
    'Get Organization Details Failure': props<{ error: string }>(),

    'Update Organization Details Success': props<{ details: any }>(),
    'Update Organization Details Failure': props<{ error: string }>(),

    
  }
});
